const e = "0.5rem", a = "#0C2A4DCC", n = "0.25rem", c = "0.5rem", o = "1rem", s = "1.5rem", t = "320px", r = "640px", m = "960px", p = "1280px", S = "0.5rem";
export {
  r as a,
  t as b,
  m as c,
  p as d,
  o as e,
  s as f,
  c as g,
  a as h,
  n as i,
  S as j,
  e as k
};
